<template>
  <el-dialog
    top="15vh"
    class="device-import__dialog"
    :title="$t('Common.importData')"
    width="900px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <div class="result">
      <div class="result-summary">{{ $t('Common.importRes') }}:</div>
      <div class="result-summary">{{ $t('Common.success') }}:{{ successData.length }}</div>
      <div class="result-summary">{{ $t('Common.fail') }}:{{ tableData.length }}</div>
      <CommonTable
        class="result-table"
        ref="table"
        :data="tableData"
        :table-json="tablejson"
        :needPagination="false"
      >
      </CommonTable>
    </div>
  </el-dialog>
</template>

<script>
import tablejson from './Model/Tablejson.ImportFail.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    successData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tablejson
    }
  },
  computed: {},
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  padding: 16px;
  background: #f4f8fe;
  border-radius: 16px;
}
.result-summary {
  margin-bottom: 16px;
  font-size: 14px;
  color: #333333;
}
.result-table {
  ::v-deep .table-header th {
    background-color: #fff;
  }
}
</style>
